import CityPageTemplate from "../city-template/CityPageTemplate";
import { dcConfig } from "./data";

export default function DcPage() {
  return <CityPageTemplate config={dcConfig} />;
}